var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircles2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 102 104",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 38,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 8,
    r: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 38,
    r: 8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 8,
    r: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 38,
    r: 8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 8,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 38,
    r: 8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 66,
    r: 10
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 66,
    r: 8
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 66,
    r: 4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 94,
    r: 8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 94,
    r: 4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 94,
    r: 10
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 94,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles2);
export default __webpack_public_path__ + "static/media/circles-2.611cc63a.svg";
export { ForwardRef as ReactComponent };